import $ from 'jquery';
import config from '../../config';
const URL_API = config.urlApi+'controlador/empleado/getGeneros.php';

export default function getGeneros(){
    return $.ajax({
        url: URL_API,
        type: 'GET'
    })
}